import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import React from "react";

import RecipeGridBranded from "./RecipeGridBranded";
import RecipeGridUnbranded from "./RecipeGridUnbranded";

export interface RecipeGridProps {
    specialty?: {
        id: string;
        title: string;
    }[];
    enabledFilters: AvailableFilters;
    placement?: string;
}

export interface AvailableFilters {
    diseases: boolean;
    courses: boolean;
    dietaryWishes: boolean;
    levelsOfComplexity: boolean;
}

// Algolia provides a pagination API.
// We don't use it with the load more feature, so setting this to max value.
export const HITS_PER_PAGE = 1000;

export const RecipeGrid = (props: RecipeGridProps): JSX.Element => {
    const { jnjFullBranded } = useJnjBranding();

    return jnjFullBranded ? <RecipeGridBranded {...props} /> : <RecipeGridUnbranded {...props} />;
};

export default RecipeGrid;
